import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { Column, Row, Typography } from 'seagull';
import { OpenInNewTab } from 'seagull/icons';
import { useResponsive } from '~/client-flow/contexts';
import { routes } from '~/constants';
import { useStoreActions } from '~/store/store-context';
import SignedAgreementAnimationWrapper from '../SignedAgreementAnimationWrapper/SignedAgreementAnimationWrapper';
import styles from './AllSetPageWithAnimations.module.scss';
import InviteIcon from './invite2.svg';
import ViewTheAgreement from './viewTheAgreement2.svg';
export const AllSetPageWithAnimationsDataTestIds = pathgen('AllSetPageWithAnimationsDataTestIds');
const AllSetPageRoutedWithAnimations = (param)=>{
    let { relationship } = param;
    const vendorName = relationship.vendor.name;
    const { isMobile } = useResponsive();
    const { logBI } = useStoreActions();
    const ClientPortal = ()=>/*#__PURE__*/ _jsxs(Column, {
            className: styles.clientPortalWrapper,
            testId: AllSetPageWithAnimationsDataTestIds.ClientPortal(),
            children: [
                /*#__PURE__*/ _jsx("a", {
                    href: routes.home,
                    onClick: ()=>logBI(10836),
                    "data-testid": AllSetPageWithAnimationsDataTestIds.ClientPortalLink(),
                    children: /*#__PURE__*/ _jsxs(Row, {
                        className: styles.visitClientPortal,
                        children: [
                            /*#__PURE__*/ _jsx(OpenInNewTab, {
                                className: styles.icon,
                                width: 18,
                                height: 18
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                skin: "link",
                                variant: "h6",
                                children: [
                                    "Visit your client portal",
                                    ' ',
                                    /*#__PURE__*/ _jsx(Typography, {
                                        as: "span",
                                        skin: "standard",
                                        variant: "h6",
                                        children: "to:"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    className: styles.nextStepsRow,
                    children: [
                        /*#__PURE__*/ _jsxs("a", {
                            className: styles.nextStepBlock,
                            "data-testid": AllSetPageWithAnimationsDataTestIds.ViewAgreement(),
                            href: routes.agreement(relationship.id),
                            onClick: ()=>logBI(10837),
                            children: [
                                /*#__PURE__*/ _jsx(ViewTheAgreement, {}),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: "View the agreement"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("a", {
                            className: styles.nextStepBlock,
                            "data-testid": AllSetPageWithAnimationsDataTestIds.InviteTeam(),
                            href: routes.team,
                            onClick: ()=>logBI(10830),
                            children: [
                                /*#__PURE__*/ _jsx(InviteIcon, {}),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: "Invite your team"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ _jsx(SignedAgreementAnimationWrapper, {
        testId: AllSetPageWithAnimationsDataTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(Column, {
            className: styles.thankYouSectionWrapper,
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    className: styles.thankYouSection,
                    testId: AllSetPageWithAnimationsDataTestIds.ThankYouSection(),
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h3",
                            weight: "normal",
                            className: styles.thankYouText,
                            children: "Thanks for signing!"
                        }),
                        /*#__PURE__*/ _jsxs(Typography, {
                            variant: "h6",
                            children: [
                                "Your agreement with ",
                                vendorName,
                                " has been approved and sent to your email."
                            ]
                        })
                    ]
                }),
                !isMobile ? /*#__PURE__*/ _jsx(ClientPortal, {}) : /*#__PURE__*/ _jsx("a", {
                    href: routes.home,
                    onClick: ()=>logBI(10836),
                    "data-testid": AllSetPageWithAnimationsDataTestIds.ClientPortalLink(),
                    children: /*#__PURE__*/ _jsxs(Row, {
                        className: styles.visitClientPortal,
                        children: [
                            /*#__PURE__*/ _jsx(OpenInNewTab, {
                                className: styles.icon,
                                width: 18,
                                height: 18
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                skin: "link",
                                variant: "h6",
                                testId: AllSetPageWithAnimationsDataTestIds.MobilePortalText(),
                                children: [
                                    "Visit your client portal",
                                    ' ',
                                    /*#__PURE__*/ _jsx(Typography, {
                                        as: "span",
                                        skin: "standard",
                                        variant: "h6",
                                        children: "for more!"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export default AllSetPageRoutedWithAnimations;
